import $api from "http";

class BrandingSettingsService {
  // Получить активные настройки брендинга
  static async getActiveSettings() {
    try {
      const response = await $api.get('/api/branding-settings/active');
      return response.data;
    } catch (error) {
      // Возвращаем дефолтные настройки при ошибке
      return {
        // Основные цвета
        primary_color: '#4783ed',
        secondary_color: '#81a8ec',

        // Цвета текста
        text_color: '#333333',
        text_light_color: '#666666',
        text_dark_color: '#000000',
        text_on_primary: '#ffffff',

        // Цвета фона
        background_color: '#f8f9fa',
        background_light: '#ffffff',
        background_dark: '#f0f0f0',
        background_hover: '#e9ecef',

        // Цвета обводок/границ
        border_color: '#dee2e6',
        border_light: '#e9ecef',
        border_dark: '#adb5bd',
        border_focus: '#4783ed',

        // Цвета состояний
        active_color: '#ffffff',
        hover_color: '#81a8ec',
        disabled_color: '#6c757d',
        disabled_background: '#e9ecef',

        // Цвета уведомлений
        success_color: '#28a745',
        success_background: '#d4edda',
        error_color: '#dc3545',
        error_background: '#f8d7da',
        warning_color: '#ffc107',
        warning_background: '#fff3cd',
        info_color: '#17a2b8',
        info_background: '#d1ecf1',

        // Цвета специальных элементов
        link_color: '#4783ed',
        link_hover_color: '#81a8ec',
        shadow_color: 'rgba(0,0,0,0.1)',

        logo_url: null, // null означает использование дефолтного логотипа
        title: 'Нет активных настроек брендинга'
      };
    }
  }

  // Получить все записи настроек (для админки)
  static async getAllSettings() {
    try {
      const response = await $api.get('/api/branding-settings');
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Создать новые настройки
  static async createSettings(data) {
    try {
      const response = await $api.post('/api/branding-settings', data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Обновить существующие настройки
  static async updateSettings(id, data) {
    try {
      const response = await $api.put(`/api/branding-settings/${id}`, data);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Удалить настройки
  static async deleteSettings(id) {
    try {
      const response = await $api.delete(`/api/branding-settings/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }

  // Активировать настройки
  static async activateSettings(id) {
    try {
      const response = await $api.patch(`/api/branding-settings/${id}/activate`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
}

export default BrandingSettingsService;
